import React from 'react';
import classNames from 'classnames';

const V5Input = ({ 
  id, 
  type = 'text', 
  value, 
  onChange, 
  label, 
  placeholder, 
  disabled = false, 
  required = false, 
  helperText, 
  error, 
  className = '', 
  name,
  maxLength,
  min,
  max 
}) => {
  const handleChange = (e) => {
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <div className={classNames('v5-form-group', className)}>
      {label && (
        <label htmlFor={id} className="v5-form-label">
          {label}
          {required && <span className="required-asterisk">*</span>}
        </label>
      )}
      <input
        type={type}
        id={id}
        name={name || id}
        className={classNames('v5-form-input', { 'is-invalid': error })}
        value={value || ''}
        onChange={handleChange}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        maxLength={maxLength}
        min={min}
        max={max}
      />
      {helperText && !error && (
        <div className="v5-helper-text">{helperText}</div>
      )}
      {error && (
        <div className="v5-error-text">{error}</div>
      )}
    </div>
  );
};

export default V5Input; 